module.exports = __WEBPACK_EXTERNAL_MODULE_198__;


//////////////////
// WEBPACK FOOTER
// external "core-js/modules/es6.string.includes"
// module id = 198
// module chunks = 0